
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'primevue/dialog';
import BillingV3Frame from '@/components/billing/BillingV3Frame.vue';

/**
 * Modal that wraps the legacy Zend interface inside an iframe.
 *
 * Used by SubscriptionPage for shops with offerVersion = v3 when they
 * trigger actions that are not implemented on the new dashboard yet
 * (change plan, buy credits). The shop sees the full Zend "remoteplan"
 * page inside the modal, handles its action there, and we close on
 * dismiss.
 */
export default defineComponent({
  name: 'LegacyBillingDialog',

  components: { Dialog, BillingV3Frame },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['update:visible'],

  setup(_, { emit }) {
    const { t } = useI18n();

    const onClose = () => emit('update:visible', false);
    const onVisibleChange = (v: boolean) => { if (!v) emit('update:visible', false); };

    return { t, onClose, onVisibleChange };
  },
});
